import assert from "assert";
import { mapNewPriceCalculationComponents } from "../screens/forms/tax/newPrice/utils/mappers";
import { IdType, Vehicle } from "../types/appTypes";
import { NewPriceData, ServerNewPriceComponents } from "../types/newPriceTypes";
import getApiEndpoint from "./apiEndpoint";
import http from "./httpService";
import { TaxCase } from "../types/taxTypes";
import { isValidVin } from "../utilities/stringExtraFunctions";

type Documents = { id: string; name: string }[];

const apiEndpoint = `${getApiEndpoint()}/vehicleNewPrice`;
type CalculationType = "optimization" | "preAssessment";
// 'type' => 'required|string|in:optimization,preAssessment',
// 'vin' => 'required|string|min:17|max:17',
// 'firstRegDate' => 'date|required',
// 'motorAtlasId' => 'sometimes|nullable|string',
// 'commercialPrices' => 'sometimes|nullable|boolean',
function getNewPriceCalculationComponents(data: {
  type: CalculationType
  vin?: string | null;
  firstRegDate: string;
  motorAtlasId?: string | null;
  commercialPrices?: boolean | null
}) {
  return http.post<{ data: ServerNewPriceComponents }>(`${apiEndpoint}/calculationComponents`, data);
}


// 'ids'=> 'required|array',
// 'ids.*' => 'required|string',
// 'vin' => 'required|string|min:17|max:17',
// 'firstRegDate' => 'date|required',
// 'commercialPrices' => 'sometimes|nullable|boolean',
function getNewPriceCalculationDocuments(data: {
  "ids": string[],
  vin: string,
  firstRegDate: string,
  commercialPrices?: boolean | null
}) {
  return http.post<{ url: string }>(`${apiEndpoint}/calculationDocuments`, data);
}
export async function downloadCarApiNewPriceDocuments(vehicle: Vehicle | null, documents: Documents) {
  assert(isValidVin(vehicle?.vin), "Stelnummer skal være gyldigt for at hente nypris of udstyr")
  assert(vehicle?.firstRegDate, "1.reg.dato påkrævet for at hente nypris of udstyr")
  const { data: { url } } = await getNewPriceCalculationDocuments({
    ids: documents.map(doc => doc.id),
    firstRegDate: vehicle?.firstRegDate,
    vin: vehicle.vin
  })
  window.open(url, "_blank")
}

export async function getNewPriceComponents(taxCase: TaxCase, type: CalculationType, currentData: NewPriceData | null) {
  assert(type === "optimization" || type === "preAssessment", "type must be either 'optimization' or 'preAssessment'")
  assert(isValidVin(taxCase.vehicle?.vin) || !!taxCase.vehicle?.motorAtlasId, "Stelnummer eller eCode skal være gyldigt for at hente nypris of udstyr")
  assert(taxCase.vehicle?.firstRegDate, "1.reg.dato påkrævet for at hente nypris of udstyr")
  assert(!!taxCase.vehicle.typeId, "Type skal angives")

  const isVan = taxCase.vehicle.typeId === 2

  const { data: { data } } = await getNewPriceCalculationComponents({
    type: type,
    firstRegDate: taxCase.vehicle?.firstRegDate,
    vin: taxCase.vehicle.vin,
    motorAtlasId: taxCase.vehicle.motorAtlasId,
    commercialPrices: isVan,
  })

  return mapNewPriceCalculationComponents(data, currentData, taxCase.vehicle)
}


